import { render, staticRenderFns } from "./CustomRadioOff.vue?vue&type=template&id=d6a3de3a&"
import script from "./CustomRadioOff.vue?vue&type=script&lang=ts&"
export * from "./CustomRadioOff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports